const currentEnv = process.env.REACT_APP_ENV || "staging";
console.log("currentEnv =>", currentEnv);

const urlHolder = {
  prod: {
    haccp: "https://7b0uky831c.execute-api.ap-northeast-1.amazonaws.com/haccp/",
    user: "https://qksusspcp2.execute-api.ap-northeast-1.amazonaws.com/api/",
    media: "https://iqdshzylr6.execute-api.ap-northeast-1.amazonaws.com/v1/",
    reports: "https://766njijtob.execute-api.ap-northeast-1.amazonaws.com/api/",
    monitoring:
      "https://0icz1e3i42.execute-api.ap-northeast-1.amazonaws.com/API/",
    guidanceEmail:
      "https://bzwpo3y4wi.execute-api.ap-northeast-1.amazonaws.com/api/",
  },
  staging: {
    haccp: "https://9m2ywwreek.execute-api.ap-northeast-1.amazonaws.com/haccp/",
    user: "https://igokofaq6j.execute-api.ap-northeast-1.amazonaws.com/api/",
    media: "https://gm445i7k9h.execute-api.ap-northeast-1.amazonaws.com/v1/",
    reports: "https://mssgoh5t07.execute-api.ap-northeast-1.amazonaws.com/api/",
    monitoring:
      "https://23j1delun8.execute-api.ap-northeast-1.amazonaws.com/API/",
    guidanceEmail:
      "https://zma8r1lnx5.execute-api.ap-northeast-1.amazonaws.com/api/",
  },
  dev: {
    haccp: "https://ssc79h65qd.execute-api.ap-northeast-1.amazonaws.com/haccp/",
    user: "https://8rxm957of5.execute-api.ap-northeast-1.amazonaws.com/api/",
    media: "https://woq2woxm2g.execute-api.ap-northeast-1.amazonaws.com/v1/",
    reports: "https://3hwata8d53.execute-api.ap-northeast-1.amazonaws.com/api/",
    monitoring:
      "https://nk9mln9crf.execute-api.ap-northeast-1.amazonaws.com/API/",
    guidanceEmail:
      "https://x7aspbb6ig.execute-api.ap-northeast-1.amazonaws.com/api/",
  },
};

const ApiConstants = {
  BASE_URL: urlHolder[currentEnv].haccp,
  VERSION: "version",
  BM_LIST: "bm",
  HOZON_TIMINGS: "bm/{:bmId}/timings",
  BM_SENSORS: "bm/{:bmId}/sensors",
  BM_MANAGE_SENSORS: "bms/{:bmId}/sensors",
  PRODUCT_SETTINGS: "product-settings",

  BASE_USER_MGMT: urlHolder[currentEnv].user,
  SETUP_ADMINS: "setup-admins",
  COMPANIES: "companies",
  SINGLE_COMPANY: "companies/{:companyId}",
  BMS: "bms",
  DEVICES: "devices",
  SINGLE_BM: "bms/{:bmId}",
  SINGLE_BM_IMAGE: "bms/{:bmId}/image",
  BM_SENSORS_UPDATE: "bms/{:bmId}/sensors",
  BM_VERSIONS: "bms/{:bmId}/versions",
  BM_COMMANDS: "bms/{:bmId}/commands",
  BM_BINFILES: "bms/{:bmId}/binfiles",
  SINGLE_BM_DATA_REPORT: "bms/{:bmId}/data/report",
  DEPARTMENTS: "departments",
  DEPARTMENT_MANAGERS: "departments/managers",
  SINGLE_DEPARTMENT_MANAGER: "departments/managers/{:managerId}",
  STORES: "stores",
  SINGLE_STORE: "stores/{:storeId}",

  BASE_MONITORING_URL: urlHolder[currentEnv].monitoring,
  MONITORING: "display-data",
  SCHEDULE_EMAILS: "schedule-reminder-emails",
  REFRESH_STORE: "refresh-store",
  SETTINGS: "settings",

  BASE_MEDIA_URL: urlHolder[currentEnv].media,

  BASE_REPORT_URL: urlHolder[currentEnv].reports,
  GENERATE_REPORT: "generate-report",
  DOWNLOAD_REPORT: "download-report",

  BASE_MAIL_URL: urlHolder[currentEnv].guidanceEmail,
  MAIL_GROUPS: "mail-groups",
  MAIL_TEMPLATES: "mail-templates",
  MAIL_HISTORY: "mail-histories",
  MAILS: "mails",

  NOTIFICATIONS: "notifications",
  USER_GUIDE: "user-docs",

  STORE_HEARING: "stores/{:storeId}/files/hearing",
  STORE_SETTINGS: "stores/{:storeId}/files/settings",
  DEVICE_SETTINGS: "devices/{:deviceId}/files",
};

export default ApiConstants;
